import { path } from "../../navigation/path";

export const menuItems = {
  messaging: {
    label: "Messaging",
    icon: "fa-solid fa-message",
    submenu: [
      {
        label: "Compose",
        icon: "fa-solid fa-pen-to-square",
        path: path.MESSAGING,
        permission: "messaging.compose",
        roles: [0, 1], // Legacy fallback
      },
      {
        label: "Transactions",
        icon: "fa-solid fa-clock",
        path: path.MESSAGE_TRANSACTIONS,
        permission: "messaging.view",
        roles: [0, 1], // Legacy fallback
      },
      {
        label: "Anniversaries",
        icon: "fa-solid fa-gift",
        path: path.MESSAGE_ANNIVERSARIES,
        permission: "messaging.view",
        roles: [0, 1], // Legacy fallback
      },
      {
        label: "Bible Verses",
        icon: "fa-solid fa-bible",
        path: path.OCCASION_VERSES,
        permission: "messaging.view",
        roles: [0, 1], // Legacy fallback
      }
    ],
  },
  members: {
    label: "Members",
    icon: "fa-solid fa-users",
    submenu: [
      {
        label: "My Information",
        icon: "fa-solid fa-user",
        path: path.MY_PROFILE,
        permission: null,
        roles: [],
        showWhenMemberId: true,
      },
      { 
        label: "List", 
        icon: "fa-solid fa-list", 
        path: path.MEMBERS, 
        permission: "member.view",
        roles: [0, 1] // Legacy fallback
      },
      {
        label: "Zones",
        icon: "fa-solid fa-map-location-dot",
        path: path.ZONES,
        permission: "zone.view",
        roles: [0], // Legacy fallback
      },
      {
        label: "Groups",
        icon: "fa-solid fa-layer-group",
        path: path.GROUPS,
        permission: "group.view",
        roles: [0], // Legacy fallback
      },
      {
        label: "Teams",
        icon: "fa-solid fa-people-group",
        path: path.TEAMS,
        permission: "team.view",
        roles: [0], // Legacy fallback
      },
    ],
  },
  vehicles: {
    label: "Vehicles",
    icon: "fa-solid fa-car",
    submenu: [
      {
        label: "Live",
        icon: "fa-solid fa-location-dot",
        // path: path.STREAM_VEHICLE,
        path: path.VEHICLE_LOGS_LIVE,
        permission: "vehicle.stream",
        roles: [0, 1], // Legacy fallback
      },
      {
        label: "Search",
        icon: "fa-solid fa-magnifying-glass",
        // path: path.VEHICLES,
        path: path.VEHICLE_LOGS_SEARCH,
        permission: "vehicle.view",
        roles: [0, 1], // Legacy fallback
      },
    ],
  },
  admin: {
    label: "Admin",
    icon: "fa-solid fa-gear",
    submenu: [
      {
        label: "Config",
        icon: "fa-solid fa-sliders",
        path: path.CONFIG,
        permission: "config.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "User Management",
        icon: "fa-solid fa-user-gear",
        path: path.USERS,
        permission: "user.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Approvals",
        icon: "fa-solid fa-check-double",
        path: path.REQUESTS,
        permission: "request.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Camera",
        icon: "fa-solid fa-video",
        path: path.CAMERAS,
        permission: "camera.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Nodes",
        icon: "fa-solid fa-microchip",
        path: path.NODES,
        permission: "node.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Audit",
        icon: "fa-solid fa-clipboard-list",
        path: path.AUDIT,
        permission: "audit.view",
        roles: [0, 1], // Legacy fallback
      },
      {
        label: "Locations",
        icon: "fa-solid fa-map-marked-alt",
        path: path.LOCATIONS,
        permission: "location.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Bible Management",
        icon: "fa-solid fa-book-bible",
        path: path.BIBLE_MANAGEMENT,
        permission: "bible.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Role Management",
        icon: "fa-solid fa-user-shield",
        path: path.ROLES,
        permission: "role.manage",
        roles: [0], // Legacy fallback
      },
      {
        label: "Master Data",
        icon: "fa-solid fa-database",
        path: path.MASTER_DATA,
        permission: null, // Super Admin only - checked via route
        roles: [0], // Super Admin only
      },
    ],
  },
  // building: {
  //   label: "Buildings",
  //   icon: "fa-solid fa-building",
  //   submenu: [
  //     {
  //       label: "Apartment",
  //       icon: "fa-solid fa-house",
  //       path: path.APPARTMENTS,
  //       roles: [0],
  //     },
  //     {
  //       label: "Companies",
  //       icon: "fa-solid fa-building-user",
  //       path: path.COMPANIES,
  //       roles: [0],
  //     },
  //     {
  //       label: "Blocks",
  //       icon: "fa-solid fa-cubes",
  //       path: path.BLOCK,
  //       roles: [0],
  //     },
  //   ],
  // },
  visitor: {
    label: "Visitors",
    icon: "fa-solid fa-person-walking",
    submenu: [
      {
        label: "List",
        icon: "fa-solid fa-list",
        path: path.VISITORS,
        permission: "visitor.view",
        roles: [0, 1], // Legacy fallback
      },
    ],
  },
};
